
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_y1yrh_11ci5_9",
  "root": "awsui_root_y1yrh_11ci5_23",
  "series--highlighted": "awsui_series--highlighted_y1yrh_11ci5_35",
  "series--dimmed": "awsui_series--dimmed_y1yrh_11ci5_39",
  "series--threshold": "awsui_series--threshold_y1yrh_11ci5_43",
  "popover-divider": "awsui_popover-divider_y1yrh_11ci5_48"
};
  